export const discoverUs = [
    {
        title: 'About Us',
        URL: '/about',
        isExternal: false
    },
    {
        title: "FAQs",
        URL: '#',
        isExternal: false
    },
    {
        title: 'Case Studies',
        URL: '#',
        isExternal: false
    },
    {
        title: 'Contact Us',
        URL: '/contact-us',
        isExternal: false
    }
]